import React from "react";
import { Link } from "gatsby";
import { Case_Arrow } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Caseusa = () => {
  return (
    <section className="case_flex">
      <div className="flex_item" style={{ backgroundColor: "#000189" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/web/case-logo-1.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={210}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Passion Painting It’s a One Stop Solution</h3>
            <Link
              to="/case-studies/passion-painting"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure website">
          <StaticImage
            src="../../images/services-usa/web/case-study-1.webp"
            alt="tekrevol_web"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={805}
            height={425}
          />
        </div>
      </div>
      <div className="flex_item web" style={{ backgroundColor: "#c43294" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/web/case-logo-2.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={157}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Unleash Your Talent, Discover Opportunities</h3>
            <Link
              to="/case-studies/talpool"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure website">
          <StaticImage
            src="../../images/services-usa/web/case-study-2.webp"
            alt="tekrevol_web"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={404}
            height={365}
          />
        </div>
      </div>
      <div className="flex_item web" style={{ backgroundColor: "#161616" }}>
        <div className="case_txt">
          <div className="case_logo">
            <StaticImage
              src="../../images/services-usa/web/case-logo-3.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={145}
              height={70}
            />
          </div>
          <div className="case_title">
            <h3>Driving Dealership Success</h3>
            <Link
              to="/case-studies/select-dealer"
              className="case-usabtn"
              aria-label="TekRevol Contact"
            >
              View Case Study {Case_Arrow}
            </Link>
          </div>
        </div>
        <div className="case_figure website">
          <StaticImage
            src="../../images/services-usa/web/case-study-3.webp"
            alt="tekrevol_web"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={404}
            height={365}
          />
        </div>
      </div>
    </section>
  );
};

export default Caseusa;
